<template>
  <div class="consent-data">
    <div class="container-box">
      <h2 class="text-3xl">Schufa</h2>
      <div class="solvency-check-terms-data" v-html="solvencycheckTerms"></div>
    </div>
    <div class="container-box">
      <AGBChecked :consentAGBProp.sync="consentAGBProp" :consentInformationArticleProp.sync="consentInformationArticleProp">
        <template #txtAGB><slot name="txtAGBWrapper"></slot></template>
        <template #lblAgbConsent><slot name="lblAgbConsentWrapper"></slot></template>
        <!-- 99/98 sind die Tarife fuer Rossmann. Bei Umbau der Slots mit nach außen ziehen -->
        <template #lblInformationArticle99><slot name="lblSmartphoneInformationArticleWrapper"></slot></template>
        <template #lblInformationArticle98><slot name="lblFriendsInformationArticleWrapper"></slot></template>
      </AGBChecked>
      <ContractSummaryDocument>
        <template #txtAfter><slot name="txtAfterContractSummary"></slot></template>
      </ContractSummaryDocument>
      <ConsultationConsent
        v-if="isOrderByAgent !== true"
        :consents="brandConsents.consents"
        :selectedInfoExchangeConsentProp.sync="selectedInfoExchangeConsentProp"
        :selectedContactConsentProp.sync="selectedContactConsentProp"
      >
        <template #txtConsultationConsent><slot name="txtConsultationConsentWrapper"></slot></template>
      </ConsultationConsent>
      <slot v-if="isOrderByAgent !== true" name="txtIndicationContractData">
        <div class="indicationContractData">
          <span class="text-base-semibold">Hinweis zur Verarbeitung von Vertragsdaten</span><br />
          <p>
            Die Vodafone-Unternehmen<sup>1</sup> dürfen meine Vertragsdaten<sup>2</sup> untereinander austauschen, um mich über
            Produkte und Dienstleistungen<sup>3</sup> von Vodafone-Unternehmen<sup>1</sup>, auch wechselseitig füreinander, zu
            informieren. Rechtsgrundlage hierfür ist Art. 6 I f) DSGVO in Verbindung mit dem berechtigten Interesse der
            Vodafone-Unternehmen<sup>1</sup> an individuell passenden Informationen über Produkte und
            Dienstleistungen<sup>3</sup>. Die Vodafone-Unternehmen<sup>1</sup>
            werden mich mit solchen Informationen nur auf Kontaktwegen kontaktieren, für die ich meine Consent erteilt habe oder
            die gesetzlich erlaubt sind, solange ich dem nicht widersprochen habe. Weitere Informationen zum Datenschutz findest
            du unter
            <a title="Datenschutz" href="/index.php/datenschutz.html" target="_blank">https://www.-mobil.de/datenschutz.html</a
            >.<br />
          </p>
          <span class="text-base-semibold"
            >Ich kann dieser Verarbeitung meiner Vertragsdaten<sup>2</sup> jederzeit schriftlich oder elektronisch für die
            Zukunft widersprechen.</span
          >
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
import AGBChecked from '@/components-v2/flows/LIDL/AGB/AGBChecked.vue'
import ConsultationConsent from '@/components-v2/flows/LIDL/AGB/ConsultationConsent.vue'
import ContractSummaryDocument from '@/components-v2/flows/LIDL/AGB/ContractSummaryDocument.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import syncProperty from '@/mixins/syncProperty'
import { mapGetters } from 'vuex'

export default {
  name: 'ShowConsentData',
  data: function() {
    return {
      brandConsents: {
        consents: []
      },
      filterKeys: ['data_handling_terms', 'bew_checkout_terms', 'solvencycheck_terms']
    }
  },
  computed: {
    solvencycheckTerms: function() {
      return this.brandConsents.consents.find(item => item.name === 'solvencycheck_terms')?.text || ''
    },
    termsVersion: function() {
      return this.brandConsents.contractTermsVersion
    },
    ...mapGetters('activation/info', ['orderByAgent']),
    isOrderByAgent: function() {
      return this.orderByAgent
    }
  },
  components: {
    AGBChecked,
    ConsultationConsent,
    ContractSummaryDocument
  },
  apollo: {
    brandConsents: function() {
      const me = this
      return wrapQuery(
        gql`
          query activation($brand: String!, $filterKeys: [String!]) {
            brandConsents(brand: $brand, filterKeys: $filterKeys) {
              consents {
                name
                text
                version
              }
              contractTermsVersion
            }
          }
        `,
        this,
        'brandConsents',
        {
          brand: this.$store.getters.brand,
          filterKeys: this.filterKeys
        },
        function(data) {
          me.contractTermsVersionProp = data.contractTermsVersion
        }
      )
    }
  },
  mixins: [
    syncProperty('contractTermsVersion', 'contractTermsVersionProp'),
    syncProperty('consentAGB', 'consentAGBProp'),
    syncProperty('consentInformationArticle', 'consentInformationArticleProp'),
    syncProperty('selectedInfoExchangeConsent', 'selectedInfoExchangeConsentProp'),
    syncProperty('selectedContactConsent', 'selectedContactConsentProp')
  ]
}
</script>
